import { orderBy } from 'lodash';
import { Conversation } from '@lgg/isomorphic/types/__generated__/graphql';

export const sortConversations = (conversations: Conversation[]) => {
  return orderBy(
    conversations,
    [
      (conversation) => {
        const dateValue = conversation.relevantUpdateAt;

        return dateValue ? new Date(dateValue).getTime() : 0;
      },
      (conversation) => conversation.id,
    ],
    ['desc', 'asc'],
  );
};
